import { Outlet } from 'react-router-dom';
import { AiChatDrawer } from '@/features/ai-assistant/components/AiChatDrawer';
import { useAttentionCount } from '@/features/attention/hooks/useAttention';
import { PageTitleProvider } from '@/store/page-title';
import { MobileNavigation } from './MobileNavigation';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/**
 * Application chrome: sidebar, topbar and the AI drawer.
 *
 * Rendered once as the router's root element, so no page has to know these
 * exist and none of them can drift apart between screens.
 */
export function AppShell() {
  const attentionCount = useAttentionCount();

  return (
    <PageTitleProvider>
      <div className="flex min-h-screen bg-canvas">
        <div className="sticky top-0 hidden h-screen lg:block">
          <Sidebar attentionCount={attentionCount} />
        </div>

        <MobileNavigation attentionCount={attentionCount} />

        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="flex-1">
            <Outlet />
          </main>
        </div>

        <AiChatDrawer />
      </div>
    </PageTitleProvider>
  );
}
